// extracted by mini-css-extract-plugin
module.exports = {"lessText":"ExpandingText_lessText__3jcH7","showMoreLink":"ExpandingText_showMoreLink__2mzFT"};